function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n  input {\n    ",
        "\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import React from "react";
import { IoIosSearch } from "react-icons/io";
import styled from "styled-components";
import i18n from "../../utils/i18n";
import Input from "../input";
var SearchBoxWrapper = styled.div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.components.searchBox.wrapper;
}, function(param) {
    var theme = param.theme;
    return theme.components.searchBox.input;
});
var SearchIcon = styled(IoIosSearch)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.components.searchBox.icon;
});
var SearchBox = function(_param) {
    var onChange = _param.onChange, placeholder = _param.placeholder, showIcon = _param.showIcon, fullWidth = _param.fullWidth, large = _param.large, rest = _objectWithoutProperties(_param, [
        "onChange",
        "placeholder",
        "showIcon",
        "fullWidth",
        "large"
    ]);
    var handleOnChange = function(e) {
        onChange === null || onChange === void 0 ? void 0 : onChange(e);
    };
    return /*#__PURE__*/ React.createElement(SearchBoxWrapper, {
        fullWidth: fullWidth,
        large: large
    }, showIcon && /*#__PURE__*/ React.createElement(SearchIcon, null), /*#__PURE__*/ React.createElement(Input, _extends({
        onChange: handleOnChange,
        placeholder: placeholder || i18n("toolbar.searchPlaceholder"),
        customWrapper: true,
        fullWidth: fullWidth,
        large: large
    }, rest)));
};
export default SearchBox;
